module.exports = function getResource(label, vars = []) {
    let resources = {
        advertising: 'Advertising'
    };

    return resources[label];
};
